let device = {
    addDevice: "Add device",
    migrate: "Migrate",
    importDevice: "Import device",
    importPayCode: "Import merchant",
    merchantBind: "Merchant bind",
    deviceDetail: "Device detail",
    pushTest: "Push Test",
    pushAT: "Push Command",
    pushSuccess: "push success",
    deviceCode: "Device No.",
    enterDeviceCode: "Device number cannot be empty",
    deviceCodeFormat: "The length of the device number is 1-32 bits, supporting letters, numbers, _-",
    startDeviceCode: "Start device No.",
    endDeviceCode: "End device No.",
    runningStatus: "Online Status",
    versionCode: "Version Code",
    versionName: "Version Name",
    offline: "Offline",
    online: "Online",
    inactive: "Inactive",
    deviceStatus: "Device Status",
    merchantNo: "Merchant No.",
    enterMerchantNo: "Please enter merchant No.",
    merchantNoTooLong: "Merchant No. too long, maximun length 32",
    specId: "Model",
    selSpecId: "Product model cannot be empty",
    initTime: "Init time",
    deviceSecret: "Device secret",
    enterDeviceSecret: "Device secret cannot be empty",
    deviceSecretFormat: "Maximum length 64, and only English letters and numbers are supported",
    deviceTotalNumber: "Total Devices",
    deviceActiveNumber: "Active Devices",
    deviceOnlineNumber: "Online Devices",
    monthDeviceTrend: "Trend chart of devices",
    errorDetail: "detail",
    deviceImportTemplate: "Device excel import template",
    payCodeImportTemplate: "Merchant excel import template",
    templateDownload: "1. Import template download",
    fileImport: "2. File Import",
    importTip: "Please modify the format before importing",
    checkedDevice: "Associated devices",
    confirmUnbind: "Unbind device {name}?",
    deviceOffline: "Device offline",
    deviceInactive: "Device inactive",
    deleteConfirmTitle: "Delete Device",
    migrateConfirmTitle: "Migrate Device",
    deviceOfCurrentPage:'Devices of current page({count})',
    deviceOfAll:'All Device({count})',
    selectDevice: "Device",
    deleteTips: 'Please select devices',
    deleteConfirm: 'Delete the selected {count} devices ?',
    deleteConfirmCurrent: 'Delete the selected {count} devices in current page?',
    deleteConfirmAll: 'Delete all the {count} devices matched the query?',
    targetOrgunit:"Migrate To",
}

export default device
